import { getMyCIOCopy } from '@/lib/mycio/translations'

/**
 * The engine's confidence bands arrive as fixed English values (aicio/confidence.py: "Secure", "On track",
 * "At risk", "Off track"). They are codes as much as words: colours, ordering and comparisons key on them, so
 * they stay English in data and are translated only at display, from the catalog the landing plan card
 * already uses (audit chunk B5, small change). Anything else — an empty value or a band this table does not
 * know — is shown as it came.
 */
const KEY = { 'secure': 'secure', 'on track': 'onTrack', 'at risk': 'atRisk', 'off track': 'offTrack' } as const

export function bandLabel(band: string | null | undefined, language: string | null | undefined): string {
  if (!band) return band ?? ''
  const key = KEY[band.trim().toLowerCase() as keyof typeof KEY]
  return key ? getMyCIOCopy(language).planCard[key] : band
}
